var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"player"},[(_vm.role === 'journalist')?_c('UserPlayer'):_vm._e(),(_vm.role === 'secretary' || _vm.role === 'admin')?_c('SecretaryPlayer'):_vm._e(),(_vm.role === 'moderator')?_c('ModeratorPlayer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }